import request from './request';

export function getPrintBannerInfo(colId) {
    return request.get(`/api/manage/banner/getPrintBannerInfo`, {
        params: {
            colId,
        },
    });
}
